// 列表
<template>
  <div class="CertificateList">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="列表" name="first">
        <div class="tab">
          <el-collapse v-model="activeNames" @change="handleChange">
            <el-collapse-item name="1">
              <template slot="title"></template>
              <div>
                <el-form
                  ref="form"
                  :model="form"
                  label-width="100px"
                  size="mini"
                  :inline="false"
                >
                  <div class="underline">
                    <el-form-item label="证书ID：">
                      <el-col :span="6">
                        <el-input v-model="form.certId"></el-input>
                      </el-col>
                    </el-form-item>
                  </div>
                  <div class="underline-first">
                    <el-form-item label="证书名称：">
                      <el-col :span="6">
                        <el-input v-model="form.certName"></el-input>
                      </el-col>
                    </el-form-item>
                  </div>
                  <div class="btn" style="text-align: center">
                    <el-row>
                      <el-button type="primary" size="mini" @click="del"
                        >清空</el-button
                      >
                      <el-button
                        type="primary"
                        size="mini"
                        @click="elExamsCertList"
                        >确认</el-button
                      >
                      <el-button size="mini" @click="toggle">关闭</el-button>
                    </el-row>
                  </div>
                </el-form>
              </div>
            </el-collapse-item>
          </el-collapse>
          <el-button type="primary" @click="toggle">搜索</el-button>
          <el-button type="primary" @click="add">添加</el-button>
        </div>
        <!-- 列表 -->
        <div class="list">
          <el-table
            ref="multipleTable"
            :data="tableData"
            border
            style="width: 100%"
            size="small"
            :header-cell-style="{ 'background-color': '#e8eff9' }"
          >
            <el-table-column
              width="50"
              label="编号"
              prop="certId"
            ></el-table-column>
            <el-table-column prop="certName" label="名称"></el-table-column>
            <el-table-column
              prop="certType"
              label="证书类型"
              width="150"
              :formatter="formatterColumn"
            ></el-table-column>
            <el-table-column prop="associationName" label="关联考试/课程名称">
            </el-table-column>
            <el-table-column prop="certUnit" label="颁发单位"></el-table-column>
            <el-table-column
              prop="certValidityTime"
              label="有效期（天）"
            ></el-table-column>
            <el-table-column prop="createTime" label="创建时间">
              <template #default="scope">{{
                (scope.row.createTime * 1000) | datetimeFormat
              }}</template>
            </el-table-column>
            <el-table-column prop="updateTime" label="更新时间">
              <template #default="scope">{{
                (scope.row.updateTime * 1000) | datetimeFormat
              }}</template>
            </el-table-column>
            <el-table-column label="操作" width="280">
              <template #default="scope">
                <span class="operation" @click="edit(scope.row)">编辑</span>
                <span class="operation" @click="delected(scope.row)">删除</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @size-change="handleListSizeChange"
          @current-change="handleListCurrentChange"
          :current-page="pageObj.page"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageObj.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="pageObj.total"
        >
        </el-pagination>
      </el-tab-pane>

      <!-- 证书列表 -->
      <el-tab-pane label="用户证书列表" name="second">
        <div class="tab">
          <el-collapse v-model="activeNames" @change="handleChange">
            <el-collapse-item name="1">
              <template slot="title"></template>
              <div>
                <el-form
                  ref="form"
                  :model="form"
                  label-width="100px"
                  size="mini"
                  :inline="false"
                >
                  <div class="underline">
                    <el-form-item label="昵称：">
                      <el-col :span="6">
                        <el-input
                          v-model="form.uName"
                          placeholder="请输入查找的人昵称、邮箱、手机号"
                        ></el-input>
                      </el-col>
                    </el-form-item>
                    <div style="padding-left: 112px; color: gray">
                      <span>输入用户昵称筛选</span>
                    </div>
                  </div>
                  <div class="underline-first">
                    <el-form-item label="证书编号：">
                      <el-col :span="6">
                        <el-input v-model="form.certCode"></el-input>
                      </el-col>
                    </el-form-item>
                  </div>
                  <div class="btn" style="text-align: center">
                    <el-row>
                      <el-button type="primary" size="mini" @click="del1"
                        >清空</el-button
                      >
                      <el-button
                        type="primary"
                        size="mini"
                        @click="elExamsUserCertList"
                        >确认</el-button
                      >
                      <el-button size="mini" @click="toggle">关闭</el-button>
                    </el-row>
                  </div>
                </el-form>
              </div>
            </el-collapse-item>
          </el-collapse>
          <el-button type="primary" @click="toggle">搜索</el-button>
        </div>
        <div class="certificate-list">
          <el-table
            ref="singleTable"
            :data="tableData1"
            border
            style="width: 100%"
            size="small"
            :header-cell-style="{ 'background-color': '#e8eff9' }"
          >
            <el-table-column prop="uname" label="用户名称"></el-table-column>
            <el-table-column prop="certNa me" label="证书名"></el-table-column>
            <el-table-column
              prop="certType"
              label="证书类型"
              width="150"
              :formatter="formatterColumn"
            ></el-table-column>
            <el-table-column
              width="150"
              label="编号"
              prop="certCode"
            ></el-table-column>
            <el-table-column prop="grade" label="等级"> </el-table-column>
            <el-table-column prop="associationName" label="关联考试/课程名称">
            </el-table-column>
            <el-table-column
              prop="certValidityTime"
              label="证书有效期（天）"
            ></el-table-column>
            <el-table-column prop="certStartTime" label="生效时间">
              <template #default="scope">{{
                (scope.row.certStartTime * 1000) | datetimeFormat
              }}</template>
            </el-table-column>
            <el-table-column prop="certEndTime" label="失效时间">
              <template #default="scope">{{
                (scope.row.certEndTime * 1000) | datetimeFormat
              }}</template>
            </el-table-column>
            <el-table-column prop="certCreateTime" label="颁发时间">
              <template #default="scope">{{
                (scope.row.certCreateTime * 1000) | datetimeFormat
              }}</template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @size-change="handleCertificateListSizeChange"
          @current-change="handleCertificateListCurrentChange"
          :current-page="pageObj1.page"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageObj1.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="pageObj1.total"
        >
        </el-pagination>
      </el-tab-pane>

      <!-- 添加 -->
      <el-tab-pane label="添加" name="third" v-if="isAdd">
        <CertificateManagementAdd @saveCertificate="saveCertificate" />
      </el-tab-pane>

      <!-- 编辑 -->
      <el-tab-pane label="编辑" name="fourth" v-if="isEdit">
        <CertificateManagementEdit
          :formDataEdit="formDataEdit"
          @saveCertificate="saveCertificate"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import CertificateManagementAdd from './CertificateManagement-add'
import CertificateManagementEdit from './CertificateManagement-edit'
import { confirmMsg } from '@/utils/common'
import * as api from '@/api/CertificateManagement/api'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: { CertificateManagementAdd, CertificateManagementEdit },
  data() {
    // 这里存放数据
    return {
      activeName: 'first',
      activeNames: [],
      form: {
        certId: '',
        certName: '',
        uName: '',
        certCode: '',
      },
      tableData: [
        {
          certId: '',
          examsPaperId: '', //关联id
          certName: '拿证-测试',
          certType: '考试证书',
          associationName: '17.内力的概念-练习',
          studentNames: '张三，李四**',
          certUnit: '拿证-测试',
          certValidityTime: '365',
          createTime: '2021-01-27',
          updateTime: '2021-01-28 ',
        },
      ],
      tableData1: [
        {
          uname: '管理员',
          certName: '英语课程证书',
          certType: '考试证书',
          certCode: '2020072911438967',
          grade: '合格',
          certValidityTime: '300',
          certStartTime: '2020-07-29',
          certEndTime: '2021-01-27',
          certCreateTime: '2021-01-28 ',
        },
      ],
      // 分页
      pageObj: {
        page: 1,
        pageSize: 20,
        total: 0,
      },
      pageObj1: {
        page: 1,
        pageSize: 20,
        total: 0,
      },
      isAdd: false,
      isEdit: false,
      formDataEdit: {},
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 方法集合
  methods: {
    handleClick(tab) {
      if (tab.name === 'first' || tab.name === 'second') {
        this.isAdd = false
        this.isEdit = false
      }
    },

    //搜索的折叠面板
    handleChange(val) {},
    toggle() {
      this.activeNames.length
        ? (this.activeNames = [])
        : (this.activeNames = ['1'])
    },

    //清空搜索内容
    del() {
      this.form.certId = ''
      this.form.certName = ''
    },

    del1() {
      this.form.uName = ''
      this.form.certCode = ''
    },

    //状态改成文字
    formatterColumn(row, column) {
      switch (row.certType) {
        case 0:
          return '考试证书'
          break
        case 1:
          return '课程证书'
      }
    },

    //获取数据
    elExamsCertList() {
      this.loading = true
      const { certId, certName } = this.form
      const { page, pageSize } = this.pageObj
      api
        .elExamsCertList({ page, pageSize, certId, certName })
        .then(({ data }) => {
          this.pageObj.page = data.data.pageNum
          this.pageObj.pageSize = data.data.pageSize
          this.pageObj.total = data.data.total
          this.tableData = data.data.list
          this.loading = false
        })
    },

    //获取用户证书列表数据
    elExamsUserCertList() {
      this.loading = true
      const { uName, certCode } = this.form
      const { page, pageSize } = this.pageObj1
      api
        .elExamsUserCertList({ page, pageSize, uName, certCode })
        .then(({ data }) => {
          this.pageObj1.page = data.data.pageNum
          this.pageObj1.pageSize = data.data.pageSize
          this.pageObj1.total = data.data.total
          this.tableData1 = data.data.list
          this.loading = false
        })
    },

    //删除数据l
    deleteList(reqdata) {
      console.log('reqdata--> ' + reqdata)
      api.deletes(reqdata).then((res) => {
        if (res.data.code === 100000) {
          if (res.data.msg === '存在分组已被使用，删除失败') {
            this.$message({ type: 'warning', message: res.data.msg })
          } else {
            this.$message({ type: 'success', message: `已删除！` })
          }
          this.elExamsCertList()
        } else {
          this.$message({ type: 'warning', message: `删除失败！` })
        }
      })
    },
    //删除个别
    delected(row) {
      confirmMsg('是否删除该条数据？', async () => {
        let reqdata = {
          certId: row.certId,
        }
        this.deleteList(reqdata)
      })
    },
    //批量删除
    batch() {
      confirmMsg('是否删除这些数据？', async () => {
        const alldata = this.$refs.multipleTable.index
        let allId = ''
        for (let i of alldata) {
          allId += i.certId + ','
        }
        let reqdata = {
          certId: allId,
        }
        console.log(reqdata)
        if (alldata.length == 0) {
          this.$message({ type: 'error', message: `请勾选` })
        } else {
          this.deleteList(reqdata)
        }
      })
    },
    //新增
    add() {
      this.isAdd = true
      this.activeName = 'third'
    },
    //新增证书保存
    saveCertificate() {
      this.elExamsCertList()
      this.isAdd = false
      this.isEdit = false
      this.activeName = 'first'
    },
    //编辑
    edit(row) {
      this.formDataEdit = row
      this.isEdit = true
      this.activeName = 'fourth'
    },
    handleListCurrentChange(page) {
      this.pageObj.page = page
      this.elExamsCertList()
    },
    handleListSizeChange(pageSize) {
      this.pageObj.pageSize = pageSize
      this.elExamsCertList()
    },
    handleCertificateListCurrentChange(page) {
      this.pageObj1.page = page
      this.elExamsUserCertList()
    },
    handleCertificateListSizeChange(pageSize) {
      this.pageObj1.pageSize = pageSize
      this.elExamsUserCertList()
    },
  },
  created() {
    this.elExamsCertList()
    this.elExamsUserCertList()
  },

  mounted() {},
}
</script>
<style lang='scss' scoped>
.tab {
  text-align: left;
  margin: 15px 0;
  font-size: 0;
  padding: 20px !important;
  background: #f6f6f6;
}

.underline {
  border-bottom: dotted;
  color: #e4e4e4;
  border-bottom-width: 2px;
  margin-bottom: 20px;
  padding-left: 115px;
}
.underline-first {
  border-bottom: solid;
  color: #e4e4e4;
  border-bottom-width: 2px;
  margin-bottom: 20px;
  padding-left: 115px;
}
/deep/.el-collapse-item__header {
  display: none;
}
/deep/.el-collapse-item__wrap {
  border: none;
}
/deep/.el-collapse {
  border: none;
  padding-bottom: 20px;
}
</style>